module.exports = __webpack_public_path__ + "img/hero-mobile.3032c5b6.webp";